/**
 * Normalizes text by removing diacritics (accents) for search purposes
 * @param text The text to normalize
 * @returns Normalized text without diacritics in lowercase
 */
export function normalizeTextForSearch(text: string): string {
  if (!text) return "";

  return text
    .toLowerCase()
    .normalize("NFD") // Decompose characters into base + combining marks
    .replace(/[\u0300-\u036f]/g, ""); // Remove combining diacritical marks
}

/**
 * Checks if searchTerm is found in text, ignoring diacritics and case
 * @param text The text to search in
 * @param searchTerm The term to search for
 * @returns True if searchTerm is found in text (ignoring diacritics and case)
 */
export function includesIgnoringDiacritics(
  text: string,
  searchTerm: string
): boolean {
  if (!text || !searchTerm) return false;

  const normalizedText = normalizeTextForSearch(text);
  const normalizedSearchTerm = normalizeTextForSearch(searchTerm);

  return normalizedText.includes(normalizedSearchTerm);
}
